<template>
  <div class="navbar">
    <div class="navbar__right">
      <OrderIds />
      <WebhookId />
      <KycId />
      <UserId />
      <div
        v-if="this.$route && this.$route.name === 'order-detail'"
        class="ml-3 rtl:mr-3 rtl:ml-0"
      >
        <VideoGuideDrawer :videos="GUIDE_VIDEOS" />
      </div>
      <div v-if="isDashboard" class="navbar__last-update">
        <div> {{ $t('dashboard_last_update') }} 20:00 pm </div>
        <div @click="refreshPage">
          <svg-icon icon-class="refresh" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderIds from '@/components/OrderIds'
import WebhookId from '@/components/WebhookId'
import KycId from '@/components/KycId'
import UserId from '@/components/UserId'
import VideoGuideDrawer from '@/components/VideoGuideDrawer'

const GUIDE_VIDEOS = [
  {
    title: 'tutorial_order_refund_title',
    description: 'tutorial_order_refund_description',
    videoLink: 'tutorial_order_refund_video_link',
  },
  {
    title: 'tutorial_capture_order_title',
    description: 'tutorial_capture_order_description',
    videoLink: 'tutorial_capture_order_video_link',
  },
]

export default {
  name: 'Navbar',
  components: {
    VideoGuideDrawer,
    OrderIds,
    WebhookId,
    KycId,
    UserId,
  },
  data() {
    return {
      GUIDE_VIDEOS,
    }
  },
  computed: {
    isDashboard() {
      if (this.$route && this.$route.name !== 'something-that-doesnot-exist') {
        return false
      }
      return this.$route && this.$route.name === 'dashboard-home'
    },
  },
  methods: {
    refreshPage() {
      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/_breakpoints';
.navbar {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: auto;
  padding: 15px 32px 0 32px;
  overflow: hidden;
  background: #fff;

  /* border-bottom: 1.5px solid #e5e5e5; */

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .vertical-align-text-bottom {
    vertical-align: text-bottom;
  }
}
.navbar__right {
  display: flex;
}

.navbar__last-update {
  display: flex;
  align-items: center;
  > div:first-child {
    margin-right: 10px;
    font-size: 14px;
    color: #666;
    [dir='rtl'] & {
      margin-left: 10px;
    }
  }
  > div:last-child {
    cursor: pointer;
  }
}
</style>
